import { Button } from "@dealer-center/core-components";
import type { LocalStorageItem } from "@dealer-center/core-interfaces-components";
import {
  getItemFromLocalStorage,
  getLocalStorageItem,
  setLocalStorageItem,
  useLocalStorageKeys
} from "@dealer-center/core-interfaces-components";
import styled from "styled-components";
const StyledButtonArea = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
`;

export function LocalStorageButtons() {
  const LocalStorageItems: LocalStorageItem[] = [];
  for (const friendlyKey of Object.values(useLocalStorageKeys)) {
    LocalStorageItems.push(getLocalStorageItem(friendlyKey));
  }

  return (
    <StyledButtonArea>
      <Button
        analyticsConfiguration={{
          eventName: "Export Local Storage",
          eventProperties: undefined
        }}
        onClick={() => {
          const data = LocalStorageItems.map(item => ({
            [item.actualKey]: getItemFromLocalStorage(item)
          })).reduce((acc, item) => ({ ...acc, ...item }), {});
          const json = JSON.stringify(data, null, 2);
          const blob = new Blob([json], { type: "application/json" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "dealer-center-local-storage.json";
          a.click();
          URL.revokeObjectURL(url);
        }}
      >
        Export All
      </Button>
      <Button
        analyticsConfiguration={{
          eventName: "Import Local Storage",
          eventProperties: undefined
        }}
        onClick={() => {
          const input = document.createElement("input");
          input.type = "file";
          input.accept = "application/json";
          input.onchange = async e => {
            const file = (e.target as HTMLInputElement).files?.[0];
            if (file) {
              const text = await file.text();
              const data = JSON.parse(text);
              for (const key in data) {
                setLocalStorageItem(key, data);
              }
              window.location.reload();
            }
          };
          input.click();
        }}
      >
        Import All
      </Button>
    </StyledButtonArea>
  );
}
